var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPhone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Vrstva_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    enableBackground: "new 0 0 24 24",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M4.197,1.09c0.351,0,0.688,0.144,0.933,0.398l2.938,3.026c0.257,0.266,0.386,0.614,0.386,0.962 c0,0.348-0.129,0.696-0.387,0.962L5.868,8.705C5.826,8.748,5.8,8.802,5.792,8.86c-0.009,0.057,0,0.117,0.027,0.171 c0.908,1.805,2.226,3.622,3.814,5.259c1.589,1.637,3.354,2.997,5.105,3.931c0.053,0.027,0.11,0.036,0.167,0.027 c0.055-0.009,0.108-0.036,0.15-0.079l2.199-2.267c0.258-0.264,0.596-0.397,0.934-0.397s0.675,0.134,0.934,0.399l2.937,3.025 c0.257,0.266,0.386,0.613,0.386,0.962c0,0.347-0.129,0.695-0.386,0.962l-0.512,0.526c-1.462,1.507-3.824,2.016-6.698,1.302 c-2.859-0.712-5.834-2.532-8.369-5.143c-2.535-2.611-4.303-5.678-4.993-8.623c-0.693-2.96-0.199-5.394,1.264-6.901l0.509-0.524 C3.508,1.233,3.845,1.089,4.197,1.09z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.895,12.423c-0.191-1.754-0.765-3.009-1.633-3.87c-0.869-0.861-2.135-1.425-3.902-1.606l0.198-1.924 c2.077,0.214,3.799,0.905,5.063,2.156c1.263,1.251,1.968,2.965,2.194,5.035L16.895,12.423z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.902,11.976c-0.329-2.81-1.267-4.894-2.737-6.352c-1.471-1.459-3.568-2.386-6.393-2.701L11.986,1 c3.135,0.35,5.681,1.406,7.538,3.25c1.858,1.843,2.933,4.378,3.298,7.502L20.902,11.976z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhone);
export default __webpack_public_path__ + "static/media/phone.d54ef4e24e488a78de5b63b8cf7d4529.svg";
export { ForwardRef as ReactComponent };